<template>
  <div>
    <div class="d-flex MuiPaper-bottom MuiPaper-bottom-center flex-wrap">
      <span>
        <span>
          <router-link to="/" class="del-underline white--text">
          Home
          </router-link>
          </span>
         <span>|</span>
         <span v-for="(artsit,index) in artsitList" :key="artsit.id">
           <router-link :to="'/artsit/' + artsit.author.toLowerCase().replace(' ', '')" class="del-underline white--text"
             data-testid="item-detail-link">
           {{artsit.author}}
           </router-link>
           <span v-if="index < artsitList.length - 1">|</span>
         </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
          artsitList: [{
            id: 1,
            author: 'Yin Kun',
          }, {
            id: 2,
            author: 'Yin Jun',
          }, {
            id: 3,
            author: 'Huang Xi',
          }, {
            id: 4,
            author: 'Liu Yujun',
          }, {
            id: 5,
            author: 'Yang Peng',
          }, {
            id: 6,
            author: 'Liu Fei',
          }, {
            id: 7,
            author: 'Ma Yongqiang',
          }],
        }
    },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    },
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/MenuBar.vue